// extracted by mini-css-extract-plugin
export default {"archiveUploadModal":"archive-upload-modal_archiveUploadModal__kQxYb","uploadZone":"archive-upload-modal_uploadZone__WN6Gb"};